<template>
  <div class="splash-screen">
    
  </div>
</template>

<script>
export default {
  name: "SplashScreen",
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {},
  computed: {},
  created(){
      try {
      __native_money91.location = (res, locatnPermission) => {
        console.log('====locatnPermission=',res,locatnPermission)
        if (!res && locatnPermission === "LOCATION_PERMISSION_DENIED") {
          alert("Please Enable Your App Permission1");
          // this.$router.push("/location");
        } else if (!res && locatnPermission === "LOCATION_NOT_ENABLED") {
          alert("Please Enable your App Location2");
          // this.$router.push("/location");
        } else if (res && !locatnPermission) {
           this.$router.push("/wall");
        }
      };
      JSBridgePlugin.getLocation(" __native_money91.location");
    } catch (err) {
      console.log(err);
    }
  },
  mounted() {
  }
};
</script>
<style>

</style>
